import { AxiosInstance } from "axios";
import TokenHelper from "../utils/tokenHelper";
import { storySubjectType } from "./stories";

export const basePath = "/comments";

// All the paths for this api domain.
export const commentPaths = {
  toggleCommentLike: () => "/luvit",
  postCommentToStory: () => basePath,
  reportComment: (id: number) => `${basePath}/${id}/report-abuse`,
  deleteComment: (id: number) => `${basePath}/${id}/report-abuse`,
};

class CommentApi {
  api: AxiosInstance;
  tokenHelper: TokenHelper;

  constructor(api: AxiosInstance, tokenHelper: TokenHelper) {
    this.api = api;
    this.tokenHelper = tokenHelper;
  }

  // Toggle comment like.
  // POST /luvit
  toggleCommentLike = (commentId: number) => {
    const token = this.tokenHelper.getRefreshToken();
    return this.api.post(
      commentPaths.toggleCommentLike(),
      {
        subjectType: "comment",
        subjectId: commentId,
      },
      {
        headers: {
          Authorization: this.tokenHelper.formatAuthHeader(token),
        },
      }
    );
  };

  // Post a comment.
  // POST /comments
  postCommentToStory = (subjectId: number, text: string) => {
    const token = this.tokenHelper.getJwtToken();
    return this.api.post(
      commentPaths.postCommentToStory(),
      {
        subjectType: storySubjectType,
        subjectId,
        body: text,
        // 😭 This makes me cry a little. We have the ability
        // to bypass a security check from the frontend.
        isRelaxedPermission: true,
      },
      {
        headers: {
          Authorization: this.tokenHelper.formatAuthHeader(token),
        },
      }
    );
  };

  // Report a comment.
  // POST /comments/:id/report-abuse
  reportComment = (commentId: number) => {
    const token = this.tokenHelper.getJwtToken();
    return this.api.post(commentPaths.reportComment(commentId), {
      headers: {
        Authorization: this.tokenHelper.formatAuthHeader(token),
      },
    });
  };

  // Delete a comment.
  // This uses the same endpoint as report abuse 😬. Creating a
  // separate function as this functionality should diverge at some point 🤞.
  // POST /comments/:id/report-abuse
  deleteComment = (commentId: number) => {
    const token = this.tokenHelper.getJwtToken();
    return this.api.post(commentPaths.reportComment(commentId), {
      headers: {
        Authorization: this.tokenHelper.formatAuthHeader(token),
      },
    });
  };
}

export default CommentApi;
